import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ComicDetail from "@/pages/comic-detail/page";
import ChapterReader from "@/pages/chapter-reader/page";
import About from "@/pages/about/page";
import AppLayout from "@/components/feature/AppLayout";

const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/:slug",
        element: <CategoryPage />,
      },
      {
        path: "/comic/:id",
        element: <ComicDetail />,
      },
      {
        path: "/comic/:id/chapter/:chapterId",
        element: <ChapterReader />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;